module.exports = __webpack_public_path__ + "img/рз_20.34e8167b.png";